export const Actions = {
    Manage: 'manage',
    Create: 'create',
    Read: 'read',
    Update: 'update',
    Delete: 'delete',
}

// Used in Plans Management
export const STRATEGY_TYPE_OPTIONS: { id: string; name: string }[] = [
    { id: 'ALL_LOCKED', name: 'All Locked' },
    { id: 'EDITOR_DEFINED', name: 'Editor Defined' },
    { id: 'FIRST_X', name: 'First X' },
]

export const ImagePath = {
    ToolQuestionChip: 'tools/question-chips'
}

/* Used in Video Tracking Report filters and export formatting */
export const SOURCE_LOCATION_OPTIONS = [
    'showpage',
    'homepage',
    'swipeUp',
    'previousVideo',
    'NextVideo',
]
export const DEVICE_TYPE_OPTIONS = [
    'android',
    'ios'
]

export const SOURCE_LOCATION_LABELS: Record<string, string> = {
    showpage: 'Show Page',
    homepage: 'Home Page',
}
/* Subscription Health Report filters */
export const PLATFORM_OPTIONS_HEALTH = ['IOS', 'Android']
export const COHORT_BASE_OPTIONS = ['Registered', 'FT Started']
/* Used in Subscription Report filters */
export const PLATFORM_OPTIONS = ['Apple', 'Android']
export const BILLING_CYCLE_OPTIONS = ['Monthly', 'Quarterly', 'Half Yearly', 'Yearly']
export const DETAILED_STATUS_OPTIONS = [
    'TRIAL',
    'TRIAL_EXPIRED',
    'TRIAL_CANCELLED',
    'PAID',
    'PAID_EXPIRED',
    'PAID_CANCELLED',
    'PAID_IN_GRACE',
    'TRIAL_IN_GRACE',
    'PAUSED_IN_TRIAL',
    'PAUSED_IN_PAID',
]